<template>
  <v-container class="pb-0">
    <!-- <div class="d-flex align-center">
      <span class="pr-5 text-007C92 w-500 font-18">บันทึกสุขภาพ</span>
      <v-divider></v-divider>
    </div> -->
    <v-form ref="create_info">
      <v-row style="padding: 20px">
        <!-- <v-col cols="12" lg="5" class="px-0">
          <v-row class="px-0 mx-0">
            <v-col cols="12" lg="5" align-self="center">
              <v-select
                solo
                dense
                hide-details="auto"
                v-model="selectYear"
                :items="itemYear"
                item-value="value"
                item-text="text"
                @input="filter"
              >
                <template v-slot:prepend> ปี </template>
              </v-select>
            </v-col>
            <v-col cols="12" lg="5" align-self="center">
              <v-select
                solo
                dense
                hide-details="auto"
                item-text="text"
                v-model="selectMonth"
                item-value="value"
                :items="months"
                @input="filter"
              >
                <template v-slot:prepend> เดือน </template>
              </v-select>
            </v-col>
            <v-col
              cols="12"
              lg="2"
              align-self="center"
              class="d-flex justify-end"
            >
              <span class="text-007C92 font-16 w-500">
                {{ getHealth.totals }} <span class="font-16 w-300">ครั้ง</span>
              </span>
            </v-col>
            <v-col cols="12" lg="12" v-if="getHealth.data.length !== 0">
              <v-list dense>
                <v-list-item-group v-model="selectedItem">
                  <v-list-item
                    v-for="(item, index) in getHealth.data"
                    :key="index"
                    class="my-2"
                    :value="index"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        <div class="d-flex flex-column">
                          <span class="w-500 font-18">{{
                            convertDate(item, "timeslotdentist")
                          }}</span>
                          <span class="w-300 font-16 mt-2">
                            {{ convertTimeStart(item, "timeslotdentist") }} -
                            {{ convertTimeEnd(item, "timeslotdentist") }} น.
                          </span>
                        </div>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-row>
        </v-col> -->
        <v-col cols="12" md="6" lg="6" class="pa-3">
          <v-row
            class="pa-0 ma-0"
            style="border: 1px solid #e5e5e5; border-radius: 10px"
            v-if="
              'data' in getHealth &&
              getHealth.data.length !== 0 &&
              selectedItem !== undefined
            "
          >
            <v-col
              cols="12"
              class="d-flex"
              align-self="center"
              style="height: 60px; border-bottom: 1px solid #e5e5e5"
            >
              <span class="pt-2 w-600 font-16 text-navy-50"
                >ข้อมูลเบื้องต้น</span
              >
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-14 text-313B41"> ส่วนสูง (cm.) </span>
                <v-text-field
                  class="font-14 text-313B41"
                  :readonly="view"
                  :value="
                    getHealth.data[selectedItem].height
                      ? getHealth.data[selectedItem].height
                      : 'ไม่ระบุ'
                  "
                  solo
                  hide-details="auto"
                  dense
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-14 text-313B41"> น้ำหนัก (kgs.) </span>
                <v-text-field
                  class="font-14 text-313B41"
                  :readonly="view"
                  solo
                  :value="
                    getHealth.data[selectedItem].weight
                      ? getHealth.data[selectedItem].weight
                      : 'ไม่ระบุ'
                  "
                  hide-details="auto"
                  dense
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-14 text-313B41"> BMI </span>
                <v-text-field
                  class="font-14 text-313B41"
                  solo
                  :value="convertBMI()"
                  hide-details="auto"
                  dense
                  disabled
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-14 text-313B41">
                  อุณหภูมิ (<v-icon size="12" color="#313B41"
                    >mdi-temperature-celsius</v-icon
                  >)
                </span>
                <v-text-field
                  class="font-14 text-313B41"
                  :readonly="view"
                  solo
                  :value="
                    getHealth.data[selectedItem].temperature
                      ? getHealth.data[selectedItem].temperature
                      : 'ไม่ระบุ'
                  "
                  hide-details="auto"
                  dense
                  persistent-hint
                  placeholder="กรอกอุณหภูมิ"
                >
                  <template v-slot:message="{ message }">
                    <span class="w-300 font-12 text-313B41">{{ message }}</span>
                  </template>
                </v-text-field>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-14 text-313B41"> PR (bpm.) </span>
                <v-text-field
                  class="font-14 text-313B41"
                  :readonly="view"
                  solo
                  :value="
                    getHealth.data[selectedItem].pulseRate
                      ? getHealth.data[selectedItem].pulseRate
                      : 'ไม่ระบุ'
                  "
                  hide-details="auto"
                  dense
                  persistent-hint
                >
                </v-text-field>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-14 text-313B41">
                  BP
                  <span class="w-300 font-12 text-313B41"
                    >ตัวอย่าง (120/80)
                  </span>
                </span>
                <v-text-field
                  class="font-14 text-313B41"
                  :readonly="view"
                  solo
                  hide-details="auto"
                  dense
                  persistent-hint
                  :value="
                    getHealth.data[selectedItem].bloodPressure
                      ? getHealth.data[selectedItem].bloodPressure
                      : 'ไม่ระบุ'
                  "
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-14 text-313B41"> RR (/min.) </span>
                <v-text-field
                  class="font-14 text-313B41"
                  :readonly="view"
                  :value="
                    getHealth.data[selectedItem].respiratoryRate
                      ? getHealth.data[selectedItem].respiratoryRate
                      : 'ไม่ระบุ'
                  "
                  solo
                  hide-details="auto"
                  dense
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-14 text-313B41"> DTX (mg/dl.) </span>
                <v-text-field
                  class="font-14 text-313B41"
                  solo
                  :readonly="view"
                  hide-details="auto"
                  :value="
                    getHealth.data[selectedItem].dextrostix
                      ? getHealth.data[selectedItem].dextrostix
                      : 'ไม่ระบุ'
                  "
                  dense
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" lg="4">
              <div class="d-flex flex-column">
                <span class="w-300 font-14 text-313B41"> รอบเอว (cm.) </span>
                <v-text-field
                  class="font-14 text-313B41"
                  :readonly="view"
                  :value="
                    getHealth.data[selectedItem].girth
                      ? getHealth.data[selectedItem].girth
                      : 'ไม่ระบุ'
                  "
                  solo
                  hide-details="auto"
                  dense
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" lg="6">
              <div class="d-flex flex-column">
                <span class="w-300 font-14 text-313B41">
                  ค่าออกซิเจนในเลือด
                </span>
                <v-text-field
                  class="font-14 text-313B41"
                  solo
                  :value="
                    getHealth.data[selectedItem].SpO2
                      ? getHealth.data[selectedItem].SpO2
                      : 'ไม่ระบุ'
                  "
                  :readonly="view"
                  hide-details="auto"
                  dense
                  persistent-hint
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" lg="6">
              <div class="d-flex flex-column">
                <span class="w-300 font-14 text-313B41"> การตั้งครรภ์ </span>
                <v-text-field
                  class="font-14 text-313B41"
                  :readonly="view"
                  solo
                  :value="
                    getHealth.data[selectedItem].pregnancy == 0
                      ? 'ไม่ได้ตั้งครรภ์ (Not Pregnant)'
                      : 'ตั้งครรภ์ (Pregnant)'
                  "
                  hide-details="auto"
                  :items="itemsPregnancy"
                  item-value="value"
                  item-text="text"
                  dense
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" lg="6">
              <div class="d-flex flex-column">
                <span class="w-300 font-14 text-313B41"> ดื่มแอลกอฮอล์ </span>
                <v-text-field
                  class="font-14 text-313B41"
                  :readonly="view"
                  solo
                  :value="
                    getHealth.data[selectedItem].alcohol == 0
                      ? 'ไม่ได้ดื่มแอลกอฮอล์ (Not Drinking)'
                      : 'ดื่มแอลกอฮอล์ (Drinking)'
                  "
                  hide-details="auto"
                  :items="itemsAlcohol"
                  item-value="value"
                  item-text="text"
                  dense
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" lg="6">
              <div class="d-flex flex-column">
                <span class="w-300 font-14 text-313B41"> สูบบุหรี่ </span>
                <v-text-field
                  class="font-14 text-313B41"
                  solo
                  :readonly="view"
                  hide-details="auto"
                  :value="
                    getHealth.data[selectedItem].smoke == 0
                      ? 'ไม่ได้สูบบุหรี่ (Not Smoking)'
                      : 'สูบบุหรี่ (Smoking)'
                  "
                  :items="itemsSmoke"
                  item-value="value"
                  item-text="text"
                  dense
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row class="pa-3" v-else>
            <v-col
              cols="12"
              class="noitems d-flex justify-center align-center text-center"
            >
              <h2>ไม่มีบันทึกสุขภาพ</h2>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" md="6" lg="6" class="pa-3">
          <v-row
            class="pa-0 ma-0"
            style="border: 1px solid #e5e5e5; border-radius: 10px"
            v-if="
              'data' in getHealth &&
              getHealth.data.length !== 0 &&
              selectedItem !== undefined
            "
          >
            <v-col
              cols="12"
              class="d-flex"
              align-self="center"
              style="height: 60px; border-bottom: 1px solid #e5e5e5"
            >
              <span class="pt-2 w-600 font-16 text-navy-50"
                >ข้อมูลการเข้ารับการรักษา</span
              >
            </v-col>
            <v-col cols="12" class="d-flex flex-column pt-0">
              <div class="d-flex flex-column mt-3">
                <span class="w-300 font-14 text-313B41"> โรคประจำตัว </span>
                <v-text-field
                  class="font-14 text-313B41"
                  solo
                  :value="
                    getHealth.data[selectedItem].congenital_disease
                      ? getHealth.data[selectedItem].congenital_disease
                      : 'ไม่ระบุ'
                  "
                  :readonly="view"
                  hide-details="auto"
                  dense
                ></v-text-field>
              </div>
              <div class="d-flex flex-column mt-3">
                <span class="w-300 font-14 text-313B41"> ยาที่ใช้ประจำ </span>
                <v-text-field
                  class="font-14 text-313B41"
                  solo
                  :readonly="view"
                  :value="
                    getHealth.data[selectedItem].medication
                      ? getHealth.data[selectedItem].medication
                      : 'ไม่ระบุ'
                  "
                  hide-details="auto"
                  dense
                ></v-text-field>
              </div>
              <div class="d-flex flex-column mt-3">
                <span class="w-300 font-14 text-313B41"> ยาที่แพ้ </span>
                <v-text-field
                  class="font-14 text-313B41"
                  solo
                  :value="
                    getHealth.data[selectedItem].allergyDrug
                      ? getHealth.data[selectedItem].allergyDrug
                      : 'ไม่ระบุ'
                  "
                  :readonly="view"
                  hide-details="auto"
                  dense
                ></v-text-field>
              </div>
              <div class="d-flex flex-column mt-3">
                <span class="w-300 font-14 text-313B41"> อาการปัจจุบัน </span>
                <v-text-field
                  class="font-14 text-313B41"
                  solo
                  :readonly="view"
                  :value="
                    getHealth.data[selectedItem].currentSymptoms
                      ? getHealth.data[selectedItem].currentSymptoms
                      : 'ไม่ระบุ'
                  "
                  hide-details="auto"
                  dense
                ></v-text-field>
              </div>
            </v-col>
          </v-row>
          <v-row class="pa-3" v-else>
            <v-col
              cols="12"
              class="noitems d-flex justify-center align-center text-center"
            >
              <h2>ไม่มีข้อมูลการเข้ารับการรักษา</h2>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      rule_BP: [
        (v) => {
          if (v === null) return true;
          return true;
        },
      ],
      rule_PR: [
        (v) => {
          if (v === null) return true;
        },
      ],
      selectYear: 2021,
      selectMonth: 0,
      months: [
        { value: 0, text: "ทั้งหมด" },
        { value: "01", text: "มกราคม" },
        { value: "02", text: "กุมภาพันธ์" },
        { value: "03", text: "มีนาคม" },
        { value: "04", text: "เมษายน" },
        { value: "05", text: "พฤษภาคม" },
        { value: "06", text: "มิถุนายน" },
        { value: "07", text: "กรกฎาคม" },
        { value: "08", text: "สิงหาคม" },
        { value: "09", text: "กันยายน" },
        { value: 10, text: "ตุลาคม" },
        { value: 11, text: "พฤศจิกายน" },
        { value: 12, text: "ธันวาคม" },
      ],
      selectedItem: 0,
      items: [
        { date: "10 เมษายน 2564", time: "09:00 - 09:30 น.", value: "text-1" },
        { date: "10 เมษายน 2564", time: "09:00 - 09:30 น.", value: "text-2" },
        { date: "10 เมษายน 2564", time: "09:00 - 09:30 น.", value: "text-3" },
      ],
      itemsICD10: 1,
      itemsICD9: 1,
      selectHealth: {},
      itemsPregnancy: [
        { value: 0, text: "ไม่ได้ตั้งครรภ์" },
        { value: 1, text: "ตั้งครรภ์" },
      ],
      itemsAlcohol: [
        { value: 0, text: "ไม่ได้ดื่มแอลกอฮอล์" },
        { value: 1, text: "ดื่มแอลกอฮอล์" },
      ],
      itemsSmoke: [
        { value: 0, text: "ไม่ได้สูบบุหรี่" },
        { value: 1, text: "สูบบุหรี่" },
      ],
      windowWidth: window.innerWidth,

      getHealth: {},
      view: true,
    };
  },

  props: {
    reset: { type: Boolean, default: true },
  },
  watch: {
    reset() {
      this.reset_data();
    },
    appointmentDetail() {
      this.getHealthInfo();
    },
  },
  mounted() {
    // this.displayTracking()
    this.getHealthInfo();
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    // eventBus.$off('add_user_get_data')
    this.$store.dispatch("windowWidthAction", this.windowWidth);
  },
  computed: {
    ...mapState(["appointmentDetail"]),
    ...mapGetters({
      // view: "viewHistoryTalkingGetter",
      currentPatient: "currentPatientGetter",
      // ...
    }),
    myStyle() {
      const { windowWidth } = this;
      if (windowWidth < 1264) return "border-top:1px solid #E5e5e5";
      return "border-left:1px solid #E5e5e5";
    },
    itemYear() {
      // console.log(moment().year());
      let y = [];
      y.push({ value: moment().year() - 1, text: moment().year() - 1 + 543 });
      y.push({ value: moment().year(), text: moment().year() + 543 });
      y.push({ value: moment().year() + 1, text: moment().year() + 1 + 543 });

      // console.log(y);
      return y;
    },
    info_bp() {
      const { getHealth = [] } = this;
      const { bloodPressure: v } = getHealth.data[this.selectedItem];
      let text = [];
      // console.log(v);
      // if (!this.$refs.create_info.validate()) return;
      // if (!this.$refs.create_info) return false;
      // if (this.$refs.create_info !== undefined) {
      //   if (!this.$refs.create_info.validate()) return false;
      // }
      if (v === null) return false;
      if (v === undefined) return false;
      if (v.split === undefined)
        return [{ t: "ความดันไม่ถูกต้อง", c: "red--text" }];
      if (v.split("/").length === 2) {
        if (!isNaN(parseInt(v.split("/")[0]))) {
          if (parseInt(v.split("/")[0]) > 140)
            text.push({ t: "*ความดันตัวบนสูงกว่าปกติ" });
          // return "*ความดันตัวบนสูงกว่าปกติ";

          if (parseInt(v.split("/")[0]) < 90)
            text.push({ t: "*ความดันตัวบนต่ำกว่าปกติ" });
          // return "*ความดันตัวบนต่ำกว่าปกติ";
        }
        if (!isNaN(parseInt(v.split("/")[1]))) {
          if (parseInt(v.split("/")[1]) > 90)
            text.push({ t: "*ความดันตัวล่างสูงกว่าปกติ" });
          // return "*ความดันตัวล่างสูงกว่าปกติ";
          if (parseInt(v.split("/")[1]) < 60)
            text.push({ t: "*ความดันตัวล่างต่ำกว่าปกติ" });
          // return "*ความดันตัวล่างต่ำกว่าปกติ";
        }
      } else return [{ t: "ความดันไม่ถูกต้อง", c: "red--text" }];

      return text.length === 0 ? false : text;
    },
    info_pr() {
      const { getHealth = [] } = this;
      const { pulseRate } = getHealth.data[this.selectedItem];
      // console.log(pulseRate);
      let text = [];
      // if (!this.$refs.create_info) return false;
      // if (this.$refs.create_info !== undefined) {
      //   if (!this.$refs.create_info.validate()) return false;
      // }
      if (pulseRate === null) return false;
      if (pulseRate < 60) text.push("*หัวใจเต้นช้ากว่าปกติ");
      if (pulseRate > 100) text.push("*หัวใจเต้นเร็วกว่าปกติ");
      if (pulseRate === "") return false;

      return text.length === 0 ? false : text;
    },
  },
  methods: {
    reset_data() {
      this.selectYear = moment().year();
      this.selectMonth = 0;
      this.selectedItem = 0;
    },
    // closePage() {
    //   this.$emit("close");
    //   this.reset_data();
    // },
    // filter() {
    //   let dateMonth = this.selectMonth;
    //   if (this.selectMonth === 0) dateMonth = "";
    //   (this.selectedItem = 0),
    //     this.$store.dispatch("getHealthInfoAction", {
    //       patient_id: this.currentPatient,
    //       dentist_clinic_id: sessionStorage.dentist_clinic_id,
    //       year: this.selectYear,
    //       month: dateMonth,
    //     });
    // },
    // async save() {
    //   let find_bp = true;
    //   // console.log(this.info_bp);
    //   if (this.info_bp !== false) {
    //     this.info_bp.find((v) => {
    //       if (v.t === "ความดันไม่ถูกต้อง") return (find_bp = false);
    //       return (find_bp = true);
    //     });
    //   }
    //   if (!find_bp) {
    //     this.$swal({
    //       type: "error",
    //       width: "auto",
    //       imageUrl: `${require("@/assets/icon/weather_R.png")}`,
    //       title: "รูปแบบความดันไม่ถูกต้อง ตัวอย่าง 120/80",
    //       imageWidth: 200,
    //       showCloseButton: false,
    //       showConfirmButton: false,
    //       background: "white",
    //       position: "center",
    //       timer: 3000,
    //       backdrop: false,
    //     });
    //     return;
    //   }
    //   // if (!this.$refs.create_info.validate()) return;
    //   // console.log(this.getHealth.data[this.selectedItem]);
    //   // this.$emit("submit", this.selectHealth)
    //   const { data: { message = {} } = {} } = await this.axios.put(
    //     process.env.VUE_APP_BASE_URL_2 +
    //       `/health-info?id=${this.getHealth.data[this.selectedItem]._id}`,
    //     this.getHealth.data[this.selectedItem]
    //   );
    //   await this.$store.dispatch("actionLog", {
    //     action: "edit health info",
    //     action_by: sessionStorage.account_id,
    //     path: `/health-info`,
    //     params: {
    //       id: this.getHealth.data[this.selectedItem]._id,
    //     },
    //     body: this.getHealth.data[this.selectedItem],
    //   });
    //   if (message === "success") {
    //     this.$swal({
    //       type: "success",
    //       width: "auto",
    //       imageUrl: `${require("@/assets/icon/Succes_G.png")}`,
    //       title: '<b class="alert">แก้ไขข้อมูลสำเร็จ</b>',
    //       showCloseButton: false,
    //       showConfirmButton: false,
    //       background: "white",
    //       position: "center",
    //       timer: 3000,
    //       backdrop: false,
    //     });
    //   } else {
    //     this.$swal({
    //       type: "error",
    //       width: "auto",
    //       imageUrl: `${require("@/assets/icon/weather_R.png")}`,
    //       imageWidth: 200,
    //       showCloseButton: false,
    //       showConfirmButton: false,
    //       background: "white",
    //       position: "center",
    //       timer: 3000,
    //       backdrop: false,
    //     });
    //   }

    //   // console.log(message)
    // },
    convertBMI() {
      const { getHealth = [] } = this;
      const { height, weight } = getHealth.data[this.selectedItem];
      const bmi = weight / ((height / 100) * (height / 100));
      if (isNaN(bmi)) return "0";
      return bmi.toFixed(2);
    },
    convertDate(date = "", key = "") {
      if (key === "") return "";
      const { date: date_timeslot } = date[key];

      var year1 = "";
      var year2 = "";
      year1 = moment(this.date_timeslot).locale("th").format("YYYY");
      year2 = (parseInt(year1) + 543).toString();

      return moment(date_timeslot)
        .locale("th")
        .format("DD MMMM " + year2);
    },

    convertTimeStart(time = "", key = "") {
      if (key === "") return "";
      const { time_slot_start } = time[key];
      return time_slot_start;
    },
    convertTimeEnd(time = "", key = "") {
      if (key === "") return "";
      const { time_slot_end } = time[key];
      return time_slot_end;
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },

    getHealthInfo() {
      let params = new URLSearchParams();
      params.append("limit", 5);
      params.append("page", 1);
      params.append("appointment_id", this.appointmentDetail.appointment_id);
      try {
        this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/v1/healthinfo?${params}`)
          .then((res) => {
            // console.log("res", res);
            this.getHealth = res.data.data[0];
            console.log(this.getHealth);
          });
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.left-content {
  width: 45%;
}
.right-content {
  width: 55%;
  // height: 100vh;
  margin-top: -12px;
  // margin-bottom: -12px;
  // border-left: 1px solid #babdbf;
}
.v-list-item-group .v-list-item--active {
  color: #fff;
  background: #09425a;
}
.v-list-item {
  background: rgba(239, 246, 252, 0.6);
  color: #000;
}
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
.noitems {
  height: 72vh;
  border: 1px solid #e8e9e9;
  border-radius: 10px;
}
</style>
